module.exports = __webpack_public_path__ + "static/media/split_color_pill.d35870aa.webp";